// Vendor Frontend Pages Placeholders
import React from 'react';
import { Box, Typography } from '@mui/material';

export default function NewShipments() {
  return <Box><Typography variant="h4">New Shipments</Typography></Box>;
}
